import React from "react";
import { connect } from "react-redux";
import { Breadcrumb } from "semantic-ui-react";
import { supportForUserPath, searchByRolenameSupportForUserPath, searchByUsernameSupportForUserPath  } from "routes";
import { AdminContainer } from "./styled";
import { MenuButton } from "../styled";
import { MainBodyContent } from "components";

const SupportRoleMainContainer = (props) => {
  const {
    history
  } = props;
  return (
    <MainBodyContent
      headerTitle="Role K2"
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: "Support",
              content: "Support",
              link: true,
              onClick: () => {history.push(supportForUserPath)},
            },
            { key: "role", content: "Role K2", active: true },
          ]}
        />
      }
    >
      <AdminContainer>
        <MenuButton title="Search By Username" onClick={() => history.push(searchByUsernameSupportForUserPath)} />
        <MenuButton title="Search By Role" onClick={() => history.push(searchByRolenameSupportForUserPath)} />
      </AdminContainer>
    </MainBodyContent>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportRoleMainContainer);
